// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3h4pX","signatureBlock":"Footer_signatureBlock__16JbL","signature":"Footer_signature__IW-CE"};